import { axiosSwagger } from "@/axios";

export const state = {
  // USER ADMIN ACCEPTANCE
  userAcceptance: {
    loading: false,
    data: [],
    total: 0,
  },
  allUser: {
    loading: false,
    data: [],
    total: 0,

    // for filtering
    campuses: [],
    offices: [],
    deliveryUnits: [],
  },
  allUserByOffice: {
    loading: false,
    data: [],
    total: 0,
  },
}


export const getters = {
}


export const mutations = {
  // ALL USER
  allUserLoading: (state, loading) => {
    state.allUser.loading = loading;
  },
  setAllUserData: (state, data) => {
    state.allUser.data = modifyData( data );
  },
  setAllUserFilterOfficeData: (state, data) => {
    const { campuses, offices, deliveryUnits } = filterOffices( data );

    state.allUser.campuses =  campuses;
    state.allUser.offices = offices;
    state.allUser.deliveryUnits = deliveryUnits;
  },
  setAllUserTotal: (state, total) => {
    state.allUser.total = total;
  },
  // ALL USER BY OFFICE
  allUserByOfficeLoading: (state, loading) => {
    state.allUserByOffice.loading = loading;
  },
  setAllUserByOfficeData: (state, data) => {
    state.allUserByOffice.data = modifyData( data );
  },
  setAllUserByOfficeTotal: (state, total) => {
    state.allUserByOffice.total = total;
  },
  // USER ADMIN ACCEPTANCE
  userAcceptanceLoading: (state, loading) => {
    state.userAcceptance.loading = loading;
  },
  setUserAcceptanceData: (state, data) => {
    state.userAcceptance.data = modifyData( data );
  },
  setUserAcceptanceTotal: (state, total) => {
    state.userAcceptance.total = total;
  },
}


export const actions = {
  // ADMIN: GET ALL USERS
  async getAllUser({ commit }) {
    commit("allUserLoading", true);

    return await axiosSwagger
      .get("/api/Account/All/Users")
      .then((response) => {
        commit("setAllUserData", response.data);
        // commit("setAllUserFilterOfficeData", response.data);
        commit("setAllUserTotal", response.data.length);
        commit("allUserLoading", false);

        return response;
      })
      .catch(() => {
        commit("allUserLoading", false);
      });
  },
  // ADMIN: GET ALL USERS BY DELIVERY UNIT ID
  async getAllUserByDeliveryUnitId({ commit }, id) {
    commit("allUserByOfficeLoading", true);

    return await axiosSwagger
      .get(`/api/Account/All/DeliveryUnit/${id}`)
      .then((response) => {
        commit("setAllUserByOfficeData", response.data);
        commit("setAllUserByOfficeTotal", response.data.length);
        commit("allUserByOfficeLoading", false);

        return response;
      })
      .catch(() => {
        commit("allUserByOfficeLoading", false);
      });
  },
  // ADMIN: GET ALL USER ACCEPTANCE
  async getUserAcceptance({ commit }) {
    commit("userAcceptanceLoading", true);

    return await axiosSwagger
      .get("/api/Account/Acceptance")
      .then((response) => {
        commit("setUserAcceptanceData", response.data);
        commit("setUserAcceptanceTotal", response.data.length);
        commit("userAcceptanceLoading", false);

        return response;
      })
      .catch(() => {
        commit("userAcceptanceLoading", false);
      });
  },
  // ADMIN: ACCEPT USER
  // eslint-disable-next-line no-unused-vars
  async acceptUser({ commit }, applicationUserId) {
    return await axiosSwagger
      .post(`/api/Account/AcceptUser/${applicationUserId}`)
      .then((response) => {
        return response;
      });
  },
  // GET USER
  // eslint-disable-next-line no-unused-vars
  async getUserById({ commit }, id){
    return await axiosSwagger
      .get(`/api/Account/Users/${id}`)
      .then((response) => {

        return response;
      });
  },
  // ADMIN: UPDATE USER
  // eslint-disable-next-line no-unused-vars
  async updateUser({ commit }, user) {
    return await axiosSwagger
      .put(`/api/Account/Update/${user.id}`, user)
      .then((response) => {
        // commit("updateAllUserData", user);

        return response || {};
      });
  },
  // ADMIN: UPDATE USER SETTINGS: ADMIN/DISABLE
  // eslint-disable-next-line no-unused-vars
  async updateUserAccountSetting({ commit }, data) {
    return await axiosSwagger
      .put(`/api/Account/${data.id}`, data)
      .then((response) => {

        return response;
      });
  },
  // ADMIN: UPDATE USER AS CRU
  // eslint-disable-next-line no-unused-vars
  async updateDUAsCRU({ commit }, data) {
    return await axiosSwagger
      .put(`/api/DeliveryUnit/CentralRecord/${data.id}/${data.isCRU}`)
      .then((response) => {

        return response;
      });
  },
}



// modify data for user full name
const modifyData = (arrayData) => {
  if(arrayData?.length ?? false){
    arrayData.forEach(e => {
      e.fullName = e.firstName + ' ' + e.lastName;
    });

    return arrayData;
  }

  return [];
};


const filterOffices = (arrayData) => {
  if(arrayData?.length ?? false){
    let campuses = [];
    let offices = [];
    let deliveryUnits = [];

    arrayData.forEach(e => {
      // campus
      if(!campuses.some(ee => ee.name === e.deliveryUnit.office.campus.campusName)){
        campuses.push({name: e.deliveryUnit.office.campus.campusName})
      }

      // office
      if(!offices.some(ee => ee.name === e.deliveryUnit.office.name)){
        offices.push({name: e.deliveryUnit.office.name})
      }

      // deliver unit
      if(!deliveryUnits.some(ee => ee.name === e.deliveryUnit.name)){
        deliveryUnits.push({name: e.deliveryUnit.name})
      }
    });

    return {
      campuses,
      offices,
      deliveryUnits,
    };
  }

  return [];
}